export default __webpack_public_path__ + "media/zurb/img/case-study-pen-cal/pencal-img1-6760512ef4239b9d40024136dd9c044b.jpg";